import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { useG319Query } from './hooks/useG319Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/g319Api';
import './G319Form.css';

/**
 * Compute today's date as YYYY-MM-DD string.
 */
function getTodayStr(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

const G319Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = useG319Query();
  const today = getTodayStr();

  const [shipNoFrom, setShipNoFrom] = useState('');
  const [shipNoTo, setShipNoTo] = useState('');
  const [shipDateFrom, setShipDateFrom] = useState('');
  const [shipDateTo, setShipDateTo] = useState(today);
  const [custFrom, setCustFrom] = useState('');
  const [custTo, setCustTo] = useState('');
  const [invDateFrom, setInvDateFrom] = useState('');
  const [invDateTo, setInvDateTo] = useState(today);
  const [payDateFrom, setPayDateFrom] = useState('');
  const [payDateTo, setPayDateTo] = useState(today);
  const [payTypeFrom, setPayTypeFrom] = useState('');
  const [payTypeTo, setPayTypeTo] = useState('');
  const [docStatus, setDocStatus] = useState(1);
  const [reportTypes, setReportTypes] = useState<number[]>([]);

  const handleQuery = () => {
    const req: QueryRequest = {
      shipNoFrom: shipNoFrom.trim(),
      shipNoTo: shipNoTo.trim() || 'zzzzzzzz',
      shipDateFrom: shipDateFrom,
      shipDateTo: shipDateTo,
      custFrom: custFrom.trim(),
      custTo: custTo.trim() || '\xff',
      invDateFrom: invDateFrom,
      invDateTo: invDateTo,
      payDateFrom: payDateFrom,
      payDateTo: payDateTo,
      payTypeFrom: payTypeFrom,
      payTypeTo: payTypeTo || 'z',
      docStatus: docStatus,
      reportTypes: reportTypes,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="g319-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          交運開票繳款明細 (pwg319f1)
        </h2>

        <QueryParams
          shipNoFrom={shipNoFrom}
          shipNoTo={shipNoTo}
          shipDateFrom={shipDateFrom}
          shipDateTo={shipDateTo}
          custFrom={custFrom}
          custTo={custTo}
          invDateFrom={invDateFrom}
          invDateTo={invDateTo}
          payDateFrom={payDateFrom}
          payDateTo={payDateTo}
          payTypeFrom={payTypeFrom}
          payTypeTo={payTypeTo}
          docStatus={docStatus}
          reportTypes={reportTypes}
          loading={loading}
          onShipNoFromChange={setShipNoFrom}
          onShipNoToChange={setShipNoTo}
          onShipDateFromChange={setShipDateFrom}
          onShipDateToChange={setShipDateTo}
          onCustFromChange={setCustFrom}
          onCustToChange={setCustTo}
          onInvDateFromChange={setInvDateFrom}
          onInvDateToChange={setInvDateTo}
          onPayDateFromChange={setPayDateFrom}
          onPayDateToChange={setPayDateTo}
          onPayTypeFromChange={setPayTypeFrom}
          onPayTypeToChange={setPayTypeTo}
          onDocStatusChange={setDocStatus}
          onReportTypesChange={setReportTypes}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的交運開票繳款資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default G319Form;
